'use strict';

import { UserFlowStageCollection } from '../../Collections/User/UserFlowStageCollection';
import { Entity } from '../Entity';
import { UserFlowStage } from '../User/UserFlowStage';
import { User } from './User';

export type StageVM = {
  id?: number; // existing stages have numeric id
  _tmpId: string; // stable client id for new rows
  name: string;
  color: string;
  icon: string;
  sortOrder: number;
};

export type FlowBundlePayload = {
  flowId?: number;
  flowName: string;
  loaAccess?: boolean;
  stages: {
    upserts: Array<{
      id?: number;
      clientTmpId?: string;
      name: string;
      color: string | null;
      icon: string | null;
      sortOrder: number;
    }>;
    deletes: number[];
  };
};

export class UserFlow extends Entity {
  protected id;

  protected user;

  protected name;

  protected description;

  protected dateTimeCreated;

  protected userFlowStages;

  protected indFlowAssignments;

  protected flowStages = new UserFlowStageCollection();

  protected loaAccess;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;

    // this.user = data.user;

    this.name = data.name;

    this.description = data.description;

    this.userFlowStages = data.userFlowStages;

    this.indFlowAssignments = data.indFlowAssignments;

    this.loaAccess = data.loaAccess;

    if (data.dateTimeCreated) {
      const dateTimeCreated = data.dateTimeCreated.date.split(' ')[0].split('-');
      this.dateTimeCreated =
        dateTimeCreated[1] + '/' + dateTimeCreated[2] + '/' + dateTimeCreated[0];
    }

    if (data.flowStages) {
      const flowStages = new UserFlowStageCollection();

      data.flowStages.forEach((action) => {
        const flowStage = new UserFlowStage();
        flowStage.hydrate(action);
        //flowStage.setUserStage(this);
        flowStages.addItem(flowStage);
      });

      this.flowStages = flowStages;
    }

    if (data.user) {
      const user = new User();

      user.hydrate(data.user);

      this.user = user;
    }
  }

  public getId() {
    return this.id;
  }

  public setId(id) {
    this.id = id;

    return this;
  }

  public getUser() {
    return this.user;
  }

  public setUser(user) {
    this.user = user;

    return this;
  }

  public getName() {
    return this.name;
  }

  public setName(name) {
    this.name = name;

    return this;
  }

  public getDescription() {
    return this.description;
  }

  public setDescription(description) {
    this.description = description;

    return this;
  }

  public getDateTimeCreated() {
    return this.dateTimeCreated;
  }

  public setDateTimeCreated(dateTimeCreated) {
    this.dateTimeCreated = dateTimeCreated;

    return this;
  }

  public getFlowStages() {
    return this.flowStages;
  }

  public setFlowStages(flowStages) {
    this.flowStages;
  }

  public addAutomationAction(flowStage) {
    this.flowStages.addItem(flowStage);
  }

  public isLoaAccess() {
    return this.loaAccess;
  }

  public setLoaAccess(loaAccess) {
    this.loaAccess = loaAccess;

    return this;
  }
}
